import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import Modal from '../../../../components/Modal/Modal';
import { settleCharge } from '../../../../services/finance/billingApi';
import {
   ControlInput,
   FieldHint,
   FieldLabel,
   PrimaryActionButton,
   SecondaryButton,
} from '../../../../styles/dunning/base';
import { ModalText } from '../../../../styles/dunning/modals';
import { financeErrorMessage } from '../../utils/apiError';
import { todayIso } from '../../utils/dunningFormat';

// ---------------------------------------------------------------------------
// Baixa manual de um título — NÃO otimista (não-negociável nº 5): o sucesso
// aqui só marca o título como "Aguardando webhook"; o caso muda quando o
// webhook de pagamento do Asaas chegar. Nunca pintar como pago no clique.
//
// A baixa entra pelo módulo billing (POST /billing/:id/settle) — a régua não
// tem endpoint próprio de settle, de propósito. A data do recebimento é
// escolhida pelo operador (default hoje): a apuração do pagamento pode ter
// acontecido em outro momento.
// ---------------------------------------------------------------------------

export default function SettleModal({
   isOpen,
   member = null,
   onClose,
   onConfirmed,
}) {
   const [paymentDate, setPaymentDate] = useState('');
   const [isSaving, setIsSaving] = useState(false);

   // Re-semeia a data a cada abertura (hoje como sugestão, nunca automático).
   useEffect(() => {
      if (isOpen) setPaymentDate(todayIso());
   }, [isOpen]);

   const handleConfirm = async () => {
      if (!member) return;
      if (!paymentDate) {
         toast.warn('Informe a data de recebimento.');
         return;
      }
      setIsSaving(true);
      try {
         await settleCharge(member.charge_id, paymentDate);
         toast.success(
            'Baixa enviada ao Asaas. O caso atualiza quando o webhook chegar.'
         );
         onConfirmed(member.charge_id);
         onClose();
      } catch (err) {
         toast.error(
            financeErrorMessage(err, 'Erro ao registrar baixa manual.')
         );
      } finally {
         setIsSaving(false);
      }
   };

   return (
      <Modal
         isOpen={isOpen}
         title="Dar baixa manual"
         onClose={onClose}
         maxWidth="460px"
         footer={
            <>
               <SecondaryButton type="button" onClick={onClose}>
                  Cancelar
               </SecondaryButton>
               <PrimaryActionButton
                  type="button"
                  onClick={handleConfirm}
                  disabled={isSaving || !paymentDate}
               >
                  {isSaving ? 'Enviando...' : 'Confirmar baixa'}
               </PrimaryActionButton>
            </>
         }
      >
         <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <ModalText>
               A baixa é registrada no Asaas como recebimento em dinheiro. O
               caso e o título só mudam de estado quando o webhook de pagamento
               chegar — normalmente em segundos.
            </ModalText>
            <div>
               <FieldLabel htmlFor="dunning-settle-date">
                  Data do recebimento *
               </FieldLabel>
               <ControlInput
                  id="dunning-settle-date"
                  type="date"
                  value={paymentDate}
                  max={todayIso()}
                  onChange={(event) => setPaymentDate(event.target.value)}
               />
               <FieldHint>
                  Data em que o pagamento foi de fato apurado.
               </FieldHint>
            </div>
         </div>
      </Modal>
   );
}

SettleModal.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   // eslint-disable-next-line react/forbid-prop-types
   member: PropTypes.object,
   onClose: PropTypes.func.isRequired,
   onConfirmed: PropTypes.func.isRequired,
};
